import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    AUTHORIZED_URL_PREFIX,
    AxiosConfig,
} from '../../Utils/Constants';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';

const LatestAccess = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);

    const fetchUserLatestAccess = async () => {
        try {
            setIsLoading(true);
            const { data } = await axios.get(
                `${AUTHORIZED_URL_PREFIX}/latest-access`,
                AxiosConfig()
            );
            setUsers(data.latestAccessData);  // Assuming the response data is structured as you provided
            console.log('latest access ---->', data);
            setIsLoading(false);
            if (!data.success) {
                notify(pleaseRefreshError);
            }
        } catch (error) {
            console.error(error);
            notify(pleaseRefreshError);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUserLatestAccess();
    }, []);

    const calculateDaysDifference = (latestAccess) => {
        const today = new Date();
        const accessDate = new Date(latestAccess);
        const differenceInTime = today - accessDate;
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
        return differenceInDays;
    };

    return (
        <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            minHeight="100vh"
        >
            <Paper 
                style={{ 
                    width: '80%', 
                    overflow: 'auto', 
                    maxHeight: '80vh' 
                }}
            >
                {isLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Email</TableCell>
                                <TableCell>Latest Access</TableCell>
                                <TableCell>Days Since Last Access</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map((user, index) => (
                                <TableRow key={index}>
                                    <TableCell>{user.email}</TableCell>
                                    <TableCell>{user.latestAccess ? new Date(user.latestAccess).toLocaleString() : 'No access recorded'}</TableCell>
                                    <TableCell>{user.latestAccess ? calculateDaysDifference(user.latestAccess) : 'N/A'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </Paper>
        </Box>
    );
};

export default LatestAccess;
